// Copy for the onboarding CI invitation (Founder final copy = cl-t1-onb-v2 / cl-t2-onb-v2). The consented text itself stays the versioned
// `CI_COPY[lang][tier].body` shown in each confirmation sheet; these lines only summarise it.
export const INVITE_COPY = {
  en: {
    headline: ['Help make ', 'Arvexis', ' better for everyone.'],
    sub: 'If you choose to help, your experience can contribute to more natural and useful Arvexis responses over time.',
    control: "You're always in control.",
    acceptAll: 'Accept all',
    acceptAllHint: 'Selects both options. Continue saves your choices.',
    or: 'or choose individually',
    t1: { title: 'Share feedback signals', line: "Your reactions help show which replies are working well. Your conversation text isn't included in this feedback data." },
    t2: { title: 'Share conversation patterns', line: 'Help Arvexis learn from how people communicate so replies can feel more natural over time. For collective learning, we use patterns — not the actual words you wrote.' },
    learnMore: 'Learn more',
    info: "Both options are optional. Saying no doesn't change your Arvexis experience. You can change your choices anytime in Settings.",
    continue: 'Continue',
    notNow: 'Not now',
    back: 'Back',
    on: 'On',
    cancel: 'Cancel',
    allTitle: 'Turn on both options',
    allIntro: 'Each option has its own agreement. Tick both to turn them on.',
    turnOnBoth: 'Turn on both',
    oneIntro: 'Read what is included, then tick to agree. You can change this anytime in Settings.',
    changeLater: 'This option is on. You can turn it off with its switch, or anytime in Settings.',
    close: 'Close',
  },
  es: {
    headline: ['Ayuda a que ', 'Arvexis', ' mejore para todos.'],
    sub: 'Si decides ayudar, tu experiencia puede contribuir a que las respuestas de Arvexis sean más naturales y útiles con el tiempo.',
    control: 'Tú siempre tienes el control.',
    acceptAll: 'Aceptar todo',
    acceptAllHint: 'Selecciona ambas opciones. Continuar guarda tus elecciones.',
    or: 'o elige una por una',
    t1: { title: 'Compartir señales de valoración', line: 'Tus reacciones ayudan a identificar qué respuestas funcionan mejor. El texto de tus conversaciones no se incluye en estos datos de valoración.' },
    t2: { title: 'Compartir patrones de conversación', line: 'Ayuda a Arvexis a aprender de cómo se comunican las personas para ofrecer respuestas más naturales con el tiempo. Para el aprendizaje colectivo, usamos patrones — no las palabras exactas que escribiste.' },
    learnMore: 'Más información',
    info: 'Ambas opciones son voluntarias. Si dices que no, tu experiencia con Arvexis sigue igual. Puedes cambiar tus elecciones cuando quieras en Ajustes.',
    continue: 'Continuar',
    notNow: 'Ahora no',
    back: 'Atrás',
    on: 'Activado',
    cancel: 'Cancelar',
    allTitle: 'Activar ambas opciones',
    allIntro: 'Cada opción tiene su propio consentimiento. Marca las dos para activarlas.',
    turnOnBoth: 'Activar ambas',
    oneIntro: 'Lee qué incluye y marca la casilla para aceptar. Puedes cambiarlo cuando quieras en Ajustes.',
    changeLater: 'Esta opción está activada. Puedes desactivarla con su interruptor o cuando quieras en Ajustes.',
    close: 'Cerrar',
  },
};

export const GOLD = '#E8C58F';
export const IVORY = '#F4EFE7';
